import { Pipe, PipeTransform } from '@angular/core';
/**
  * FirstNamePipe
  *
  * A pipe to return firstname from a passed in fullname.
  */
@Pipe({ name: 'firstName' })
export class FirstNamePipe implements PipeTransform {
  /**
  * Accepts a string of fullname and returns firstname.
  *
  * @param {string} value The fullname to be transformed.
  * @return {string} Returns first name.
  */
  transform(value: string): string {
    if (typeof value === 'string' && value !== '') {
      return value.split(' ')[0]
    }
    return value || '';
  }
}

